import { Legal } from "@/pages/Legal";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/legal")({
  component: Legal,
});
